import React from 'react';
import NavigationDrawer from '../NavigationDrawer';
import PageHeader from '../PageHeader';
import { LayoutContainer, MainContent } from './styles';

export interface BreadcrumbItem {
	label: string;
	onClick?: () => void;
}

interface MainLayoutProps {
	pageTitle: string;
	pageSubtitle?: string;
	breadcrumbs?: BreadcrumbItem[];
	children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({
	pageTitle,
	pageSubtitle,
	breadcrumbs,
	children,
}) => {
	return (
		<LayoutContainer>
			<NavigationDrawer />
			<MainContent>
				<PageHeader
					title={pageTitle}
					subtitle={pageSubtitle}
					breadcrumbs={breadcrumbs}
				/>
				{children}
			</MainContent>
		</LayoutContainer>
	);
};

export default MainLayout;
